// 菜单数据API服务
import axios from 'axios'

// 创建axios实例
const api = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || '/api',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 可以在这里添加token等认证信息
    // const token = localStorage.getItem('token')
    // if (token) {
    //   config.headers.Authorization = `Bearer ${token}`
    // }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response
  },
  error => {
    console.error('API请求错误:', error)
    return Promise.reject(error)
  }
)

// 菜单服务工具函数
// 注意：API调用现在直接在组件中使用 this.$http 进行

/**
 * 获取菜单数据的模拟实现
 * 在实际项目中，请替换为真实的API调用
 * @returns {Promise} 返回模拟的菜单数据
 */
export const getMockMenuData = async () => {
  // 模拟API延迟
  await new Promise(resolve => setTimeout(resolve, 300))
  
  // 模拟返回的数据结构
  return {
    code: 200,
    message: 'success',
        data: [
          {
            id: 1,
            name: '首页',
            path: '/',
            icon: 'home',
            children: []
          },
          {
            id: 2,
            name: '产品服务',
            path: '/news',
            url: '/product',
            icon: 'product',
            bannerUrl: require('../assets/img/about2.png'),
            children: [
              {
                id: 21,
                name: 'CRISPR基因编辑平台',
                path: '/news/crispr-platform',
                url: 'https://www.example.com/crispr-platform',
                icon: 'crispr',
                children: [
                  { id: 211, name: '新型CRISPR开发', path: '/news/crispr-development', url: 'https://www.example.com/crispr-development', icon: 'development' },
                  { id: 212, name: 'CRISPR蛋白优化', path: '/news/crispr-protein', url: 'https://www.example.com/crispr-protein', icon: 'protein' },
                  { id: 213, name: 'sgRNA靶点筛选', path: '/news/sgrna-screening', url: 'https://www.example.com/sgrna-screening', icon: 'sgrna' },
                  { id: 214, name: '基因编辑递送工具', path: '/news/delivery-tools', url: 'https://www.example.com/delivery-tools', icon: 'delivery' },
                  { id: 215, name: '基因编辑有效性验证', path: '/news/validity-test', url: 'https://www.example.com/validity-test', icon: 'validity' },
                  { id: 216, name: '基因编辑细胞系', path: '/news/cell-lines', url: 'https://www.example.com/cell-lines', icon: 'cell' },
                  { id: 217, name: 'CRISPR文库', path: '/news/crispr-library', url: 'https://www.example.com/crispr-library', icon: 'library' }
                ]
              },
              {
                id: 22,
                name: 'CRISPR实验服务',
                path: '/news/experiment-services',
                url: 'https://www.example.com/experiment-services',
                icon: 'experiment',
                children: [
                  { id: 221, name: '新型CRISPR PAM特征化实验', path: '/news/pam-characterization', url: 'https://www.example.com/pam-characterization', icon: 'pam' },
                  { id: 222, name: '新型CRISPR切割效率确认', path: '/news/cutting-efficiency', url: 'https://www.example.com/cutting-efficiency', icon: 'cutting' },
                  { id: 223, name: 'CRISPR On/Off-target预测建模', path: '/news/prediction-modeling', url: 'https://www.example.com/prediction-modeling', icon: 'prediction' }
                ]
              }
            ]
          },
      {
        id: 3,
        name: '技术平台',
        path: '/platform',
        url: '/platform',
        children: [
          {
            id: 31,
            name: '基因编辑技术',
            path: '/product/gene-editing',
            url: 'https://www.example.com/gene-editing',
            icon: 'technology'
          },
          {
            id: 32,
            name: '递送系统',
            path: '/product/delivery-system',
            url: 'https://www.example.com/delivery-system',
            icon: 'delivery-system'
          }
        ]
      },
      {
        id: 4,
        name: '新闻中心',
        path: '/news',
        url: '/news',
        icon: 'news',
        children: [
          {
            id: 41,
            name: '行业动态',
            path: '/case/industry',
            url: 'https://www.example.com/industry',
            icon: 'industry',
            children: [
              { id: 411, name: '最新资讯', path: '/case/latest-news', url: 'https://www.example.com/latest-news', icon: 'latest' },
              { id: 412, name: '技术前沿', path: '/case/tech-frontier', url: 'https://www.example.com/tech-frontier', icon: 'frontier' },
              { id: 413, name: '政策法规', path: '/case/policy', url: 'https://www.example.com/policy', icon: 'policy' }
            ]
          },
          {
            id: 42,
            name: '公司动态',
            path: '/case/company-news',
            url: 'https://www.example.com/company-news',
            icon: 'company',
            children: [
              { id: 421, name: '公司新闻', path: '/case/company-news', url: 'https://www.example.com/company-news', icon: 'company-news' },
              { id: 422, name: '产品发布', path: '/case/product-release', url: 'https://www.example.com/product-release', icon: 'release' },
              { id: 423, name: '合作案例', path: '/case/cooperation', url: 'https://www.example.com/cooperation', icon: 'cooperation' }
            ]
          }
        ]
      },
      {
        id: 5,
        name: '关于我们',
        path: '/about',
        icon: 'about',
      }
    ]
  }
}

// 默认菜单数据（作为fallback）
export const getDefaultMenuData = () => {
  return [
    { id: 1, name: '首页', path: '/', icon: 'home', children: [] },
    { id: 2, name: '产品服务', path: '/news', icon: 'product', children: [] },
    { id: 3, name: '技术平台', path: '/product', icon: 'platform', children: [] },
    { id: 4, name: '新闻中心', path: '/case', icon: 'news', children: [] },
    { id: 5, name: '关于我们', path: '/about', icon: 'about', children: [] }
  ]
}

export default {
  getMockMenuData,
  getDefaultMenuData
}

// 新增：获取某个菜单节点的完整树
export const getMenuFullTree = async (menuId) => {
  const id = String(menuId)
  return api.get(`/menus/${encodeURIComponent(id)}/full-tree`)
}